
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      {/* 背景圖片 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/c4144ff4e4114f464ab5d870d8ed79ef.jpg')`
        }}
      />
      
      {/* 內容區域 */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          {/* 主標題 - H1標籤用於SEO */}
          <header>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
              探索命運的奧秘
            </h1>
          </header>
          
          {/* 副標題 - 包含關鍵詞 */}
          <h2 className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
            專業的<strong>塔羅占卜</strong>、<strong>八字算命</strong>、<strong>紫微斗數</strong>、<strong>星座運勢</strong>命理諮詢服務
            <br />
            24小時線上即時諮詢，資深命理師為您解讀人生方向
          </h2>
          
          {/* 服務特色 - 語義化標籤 */}
          <article className="mb-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-magic-line text-2xl text-yellow-400"></i>
                </div>
                <h3 className="font-semibold mb-2">塔羅占卜</h3>
                <p className="text-sm text-gray-300">愛情運勢預測</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-ancient-gate-line text-2xl text-orange-400"></i>
                </div>
                <h3 className="font-semibold mb-2">八字算命</h3>
                <p className="text-sm text-gray-300">事業財運分析</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-compass-3-line text-2xl text-purple-400"></i>
                </div>
                <h3 className="font-semibold mb-2">紫微斗數</h3>
                <p className="text-sm text-gray-300">性格命運解讀</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-star-line text-2xl text-blue-400"></i>
                </div>
                <h3 className="font-semibold mb-2">星座運勢</h3>
                <p className="text-sm text-gray-300">每日運勢指導</p>
              </div>
            </div>
          </article>
          
          {/* 行動按鈕 */}
          <nav className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/chat')}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              aria-label="立即開始命理諮詢"
            >
              <i className="ri-chat-3-line mr-2"></i>
              立即諮詢
            </button>
            
            <button
              onClick={() => navigate('/booking')}
              className="bg-white/20 backdrop-blur-sm border border-white/30 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
              aria-label="預約專業命理師服務"
            >
              <i className="ri-calendar-line mr-2"></i>
              預約服務
            </button>
          </nav>
          
          {/* 信任指標 */}
          <aside className="mt-12 text-center">
            <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-gray-300">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-green-400 mr-2"></i>
                <span>專業認證命理師</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-blue-400 mr-2"></i>
                <span>24小時線上服務</span>
              </div>
              <div className="flex items-center">
                <i className="ri-user-heart-line text-pink-400 mr-2"></i>
                <span>超過1000位滿意客戶</span>
              </div>
              <div className="flex items-center">
                <i className="ri-star-fill text-yellow-400 mr-2"></i>
                <span>4.8星好評推薦</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
      
      {/* 裝飾元素 */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-yellow-400/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-purple-400/20 rounded-full blur-xl animate-pulse delay-1000"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-pink-400/20 rounded-full blur-xl animate-pulse delay-500"></div>
    </section>
  );
}
